<template>
    <div :class="classModal">
        <div class="modal-background" ></div>
        <div class="modal-card" v-if="typeConfiguration==null">
            <header class="modal-card-head" >
                <p class="modal-card-title" style="width:90%" >Type de poules</p>	
                <div style="float:rigth" >
                    <s-button v-if="club.id!='demo'" theme="" label="" icon="times-circle" @onclick="close()"/>
                </div>

            </header>
            <section class="modal-card-body">
                <label class="title is-5">
                     2 modes sont possibles pour les poules de qualifications :
                </label>
                <div class="typeConfig">
                    <b>Poule en mode classique</b> <br/> <i>Règle standard</i>
                    <div class="desc">
                    Tous les joueurs se rencontrent sur 3 parties<br/>
                    Les x (à vous le déterminer) meilleurs  seront qualifiées selon le nombre de parties gagnées et le goal average 
                    </div>
                    <div class="buttonBottom">
                        <s-button icon="flag" @onclick="typeConfiguration='classique'" theme="is-primary" label="choisir"/>
                    </div>
                </div>
                <div class="typeConfig">
                    <b>Poule en mode gagnant-gagnant</b> <br/> <i>Règle officielle de pétanque</i>
                    <div class="desc">
                    Les gagnants et les perdants de la première partie se rencontrent dans la deuxième partie.
                    L'équipe qui a gagné ses 2 premières parties est qualifié, l'équipe qui a perdu ses 2 premières parties est disqualifiée.
                    Les équipes qui ont gagnés qu'une partie sur les 2 se recontrent dans un troixème tour : les barrages.
                    Les 2 premiers de chaque poules sont qualifiées. 
                    </div>
                    <div class="buttonBottom">
                        <s-button icon="flag" @onclick="typeConfiguration='gg'" theme="is-primary" label="choisir"/>
                    </div>
                </div>
               
            </section>    
        </div>
        
        <div class="modal-card" v-if="typeConfiguration!=null">
            <header class="modal-card-head" >
                <p class="modal-card-title" style="width:90%" >Configurer votre tournoi</p>	
                <div style="float:rigth" >
                    <s-button v-if="club.id!='demo'" theme="" label="" icon="times-circle" @onclick="$emit('close')"/>
                </div>

            </header>
            <section class="modal-card-body">
                <div v-if="!waiting">
                    <s-button @onclick="typeConfiguration=null" icon="undo" label="retour" theme="is-warning"/>
                    <br/><br/>
                    <div class="footer-team">
                            <div>
                        <b> Il y a {{nbEquipes}} équipes</b>
                            </div>
                    </div>  
                    <div v-if="typeConfiguration=='classique'">
                        <b> Nombre de qualifiés par poules </b><br/>
                        <s-button label="1" @onclick="nbQualifie=1" :theme="nbQualifie==1 ? 'is-success' : 'is-info'"/>&nbsp;&nbsp;
                        <s-button label="2" @onclick="nbQualifie=2" :theme="nbQualifie==2 ? 'is-success' : 'is-info'"/>&nbsp;&nbsp;
                        <s-button label="3" @onclick="nbQualifie=3" :theme="nbQualifie==3 ? 'is-success' : 'is-info'"/>&nbsp;&nbsp;
                        <s-button label="4" @onclick="nbQualifie=4" :theme="nbQualifie==4 ? 'is-success' : 'is-info'"/>
                    </div>
                    <label class="title is-5">
                        Plusieurs configuration sont possibles :
                    </label>
                    <div v-for="jsonChampionnat in configurations">
                        <choice-configuration 
                            :jsonChampionnat="jsonChampionnat"
                            :typeConfiguration="typeConfiguration"
                            :nbQualifie="nbQualifie"
                            @choiceConfiguration="choiceConfiguration"/>
                    </div>
                </div>
                <div v-if="waiting">
                    Le système prépare les poules dans la configuration choisie...<br/>
                    Veuillez patienter ...
                </div>
            </section>
            
        </div>
    </div>
</template>
<style scoped>
    .buttonBottom {
        width: 100%;
        text-align: right;
    }
    .desc {
        font-size: 14px;
    }
    .typeConfig {
        margin: 5px;
        padding: 10px;
        border: thin silver solid;
        color: black;
        cursor: hand;
    }
    .footer-team {
        border: thin dashed black;
        padding: 5px;
        margin-bottom: 10px;
    }
</style>
<script>
import Championnat from "@/firebase/championnat/tirage"
import joueurFCT from "@/firebase/joueur"
import Championnat_DB from "@/firebase/championnat"
import choiceConfiguration from "@/views/tournoi/championnat/choiceConfiguration.vue"
export default {
    props: ["club", "tournoi"],
    components: {
        choiceConfiguration
    },
    data() {
        return {
            nbEquipes: 0,
            classModal: "modal is-active",
            addJoueursAnonymes: 0,
            configurations: [],
            typeConfiguration: null,
            nbQualifie: 2,
            waiting: false
        }
    },  
    methods: {
        close() {
            this.waiting = false;
            this.$emit("close");
            
        },
        async choiceConfiguration(nbPool, nbResteQualifie) {
            var nbJoueurs = this.tournoi.joueurs.length;
            
            var tournoiJoueurs = [];
            this.tournoi.joueurs.forEach(joueurTournoi=>{
                if (typeof(joueurTournoi.meneur)!="undefined")
                    if (joueurTournoi.meneur)
                        tournoiJoueurs.push(JSON.parse(JSON.stringify(joueurTournoi)))
            })
            this.tournoi.joueurs.forEach(joueurTournoi=>{
                if (typeof(joueurTournoi.meneur)=="undefined")
                    tournoiJoueurs.push(JSON.parse(JSON.stringify(joueurTournoi)))
                else if (!joueurTournoi.meneur)
                    tournoiJoueurs.push(JSON.parse(JSON.stringify(joueurTournoi)))
            })
            
            this.tournoi.joueurs = tournoiJoueurs;
            
            this.tournoi.options.championnat = {
                type: this.typeConfiguration,
                nbQualifie: this.nbQualifie,
                nbPool: nbPool,
                nbResteQualifie: nbResteQualifie
            } 
            
            // peut être mettre à jour à vérifir si dans init on le fait pas
            this.waiting = true;
            await Championnat_DB.object.init(this.club, this.tournoi, this.nbEquipes, nbPool);
            this.waiting = false;
            this.$emit("start");
        },
        
        nbPool4(jsonChampionnat) {
            var nbPool4 = 0;
            jsonChampionnat.forEach(pool=>{
                if (pool.joueurs.length==4)
                    nbPool4++;
            })
            return nbPool4;
        }
    },
    mounted() {
        this.nbEquipes = 0;
        this.tournoi.joueurs.forEach(joueur=>{
            this.nbEquipes = (joueur.meneur) ? parseInt(this.nbEquipes+1) : parseInt(this.nbEquipes);
        })
        this.waiting = false;
        var bool = true;
        var nbPool = null;
        if (this.nbEquipes>0) {
            while (bool) {
                var optionChampionnat = {
                    nbJoueursParPool: 4,
                    nbMinJoueursParPool: 3,
                    nbJoueurs: this.nbEquipes,
                    nbTourPool: 1
                }
                var tirage = new Championnat(optionChampionnat);
                if (nbPool == null)
                    tirage.initPools();
                else
                    tirage.initPools(nbPool);
                var jsonChampionnat = tirage.getJson();
                
                this.configurations.push(jsonChampionnat);
                var howNbPools = tirage.howNbPools();
                jsonChampionnat.howNbPools = howNbPools;
                var equipeIdeal = tirage.findNbEquipeIdeal(howNbPools.nbPool);
                jsonChampionnat.equipeIdeal = equipeIdeal;
                var nbPool = howNbPools.nbPool + 1;
                var nbPool4 = this.nbPool4(jsonChampionnat);
                bool = nbPool4 > 2;
            }
        
        }
        
        

    }
}
</script>